/**
 * @generated SignedSource<<0b54a564b9a8f797761a73e68c3f809a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizFilters_participativeModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizViewerFilters_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "595cd616965e74039231ce0c607c2828";

module.exports = node;
